import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const ServicePrice = ({ price, pricePeriod, isMobile }) => {
  const priceWithPeriod = !Number.isNaN(price) ? `${price} ₽ ${pricePeriod}` : '';

  return (
    <div className={cx('component', { isMobile })}>
      {priceWithPeriod}
    </div>
  );
};

ServicePrice.propTypes = {
  price: PropTypes.number,
  isMobile: PropTypes.bool,
  pricePeriod: PropTypes.string,
};
